import React from 'react';
import styled from 'styled-components';
import { SectionParent, B1 } from '../../StyledComponents';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Geekwire from '../../../assets/v2/News/GeekWire.png';
import Stacey from '../../../assets/v2/News/stacey.png';
import Sdtimes from '../../../assets/v2/News/sdtimes.png';
// import DailyHunt from '../../../assets/v2/News/DailyHunt.png';
import Entre from '../../../assets/v2/News/Entre.png';
import Techcircle from '../../../assets/v2/News/Techcircle.png';
import Yourstory from '../../../assets/v2/News/Yourstory.png';
// import Deal from '../../../assets/v2/News/Deal.png';
import Newsanyway from '../../../assets/v2/News/newsanyway.png';
import Inc42 from '../../../assets/v2/News/Inc42.png';
import Inventiva from '../../../assets/v2/News/Inventiva.png';
import SupplyChain from '../../../assets/v2/News/supplychain_white.svg';
import Cision from '../../../assets/v2/News/cision.png';

const Section = styled(SectionParent)`
  display: grid;
  justify-items: center;
  width: 100%;
  padding-bottom: 3rem;
  background-color: #f9f9fb;
`;
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding-top: 2rem;
  padding-bottom: 3rem;
  /* flex-wrap: wrap; */
  width: 75%;
  margin-right: -3rem;
  margin-left: -3rem;
  justify-content: center;
  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    padding-top: 0rem;
    margin-top: -1rem;
    padding-bottom: 2rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  min-width: 17rem;
  /* flex: 0 0 calc(25%); */
  margin-top: 2rem;
  width: 95%;
  margin-right: 1rem;
  position: relative;
  background: white;
  box-shadow: 0 1px 4px 0 rgba(66, 56, 128, 0.3);
  border-radius: 8px;
  /* margin-left: 12%; */
  position: relative;
  @media (max-width: 768px) {
    flex: 0 0 calc(100%);
    /* display: grid; */
    justify-items: center;
  }
  @media (max-width: 520px) {
    margin-left: 0.5rem;
  }
  @media (max-width: 400px) {
    min-width: unset;
    width: 100%;
    margin-left: 0;
  }
`;
const GridTop = styled.div`
  min-height: 10rem;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  align-content: center;
  display: grid;
  border-bottom: 1px solid #e3e5e7;
`;

const GridBottom = styled.div`
  min-height: 3rem;
  padding: 1rem;
  width: 100%;
`;

const GridBottomText = styled(B1)`
  text-align: left;
  color: #151828;
  min-height: 6rem;
`;
const GridBottomDate = styled(B1)`
  text-align: left;
  padding-bottom: 1rem;
  padding-top: 1rem;
  color: #4f5576;
  font-weight: bold;
`;
const GridBottomLink = styled(B1)`
  text-align: left;
  padding-bottom: 1rem;
  padding-top: 1rem;
  width: fit-content;
  color: #3e5aed;
  cursor: pointer;
  :after {
    content: '';
    display: block;
    width: 0;
    height: 5px;
    border-radius: 8px;
    background: #6650ae;
    transition: width 0.3s;
  }

  :hover::after {
    width: 100%;
    border-radius: 8px;
  }
`;

const imageStyleTop = {
  width: '90%',
  margin: 'auto',
};

const ImgContainerTop = styled.div`
  display: grid;
  width: 100%;
  justify-content: center;
  grid-column: span 1;
`;
const NewsArray = [
  {
    itemImage: Cision,
    date: '04-08-2020',
    content: `"Together, [Esper and Point Mobile] can help our customers in the supply chain, energy, and materials industries streamline operations and gain a competitive edge with connected Android," says Shiv Sundar, COO of Esper.`,
    link:
      'https://www.prweb.com/releases/esper_partners_with_point_mobile_on_lifecycle_management_for_rugged_android_devices/prweb17286310.htm#!',
    background: '#fff',
    alt:
      'Esper Partners with Point Mobile on Lifecycle Management for Rugged Android Devices',
  },
  {
    itemImage: SupplyChain,
    date: '03-06-2020',
    content: `Android DevOps platform Esper announced a logistics & transportation industry collaboration with Bluebird, Inc, a leading global provider of rugged handheld mobile computers.`,
    link:
      'https://www.supplychaindive.com/press-release/20200603-esper-and-bluebird-announce-android-partnership-to-modernize-logistics-tr/',
    background: '#000',
    alt:
      'Android DevOps platform Esper announced a logistics & transportation industry collaboration with Bluebird',
  },
  {
    itemImage: Newsanyway,
    date: '23-06-2020',
    content: `Esper announces an Android payment solution partnership with Worldnet on a complete set of cloud developer tools for contactless and self-serve payments.`,
    link:
      'https://www.newsanyway.com/2020/06/23/worldnet-and-esper-partner-on-android-solutions-for-contactless-self-serve-payments/',
    background: '#ffffff',
    alt: 'Worldnet and Esper Partner on Android Solutions',
  },
  {
    itemImage: Entre,
    date: '15-04-2020',
    content:
      'Esper COO Shiv Sundar explains why Android is the path to mobile modernization in the Indian supply chain.',
    link: 'https://www.entrepreneur.com/article/349295',
    background: '#000000',
    alt: 'Entrepreneur India',
  },
  {
    itemImage: Geekwire,
    date: '13-02-2020',
    content:
      'DevOps for IoT device fleets: Ex-Microsoft, Amazon leaders raise $7.6M for Seattle-area startup Esper ',
    link:
      'https://www.geekwire.com/2020/devops-iot-device-fleets-ex-microsoft-amazon-leaders-raise-7-6m-seattle-area-startup-esper/',
    background: '#ffffff',
    alt: 'GeekWire',
  },
  {
    itemImage: Stacey,
    date: '18-02-2020',
    content: 'Esper wants to make Android a stable platform for the IoT',
    link:
      'https://staceyoniot.com/esper-wants-to-make-android-a-stable-platform-for-the-iot/',
    background: '#0f4983',
    alt: 'Stacey',
  },
  {
    itemImage: Sdtimes,
    date: '14-02-2020',
    content: `Esper announces new funding for its Android IoT DevOps platform`,
    link:
      'https://sdtimes.com/softwaredev/esper-offers-a-full-stack-development-and-management-platform-for-android-edge-devices/',
    background: '#ffffff',
    alt: 'SdTimes',
  },
  {
    itemImage: Entre,
    date: '13-02-2020',
    content:
      'Android Device Management Platform Provider Esper Raises $7.6 Mln In Series A Funding',
    link: 'https://www.entrepreneur.com/article/346352',
    background: '#000000',
    alt: 'Entrepreneur India',
  },
  {
    itemImage: Inc42,
    date: '13-02-2020',
    content:
      'Esper Looks To Strengthen Indian Presence With $7.6 Mn Series A Funding',
    link:
      'https://inc42.com/buzz/esper-looks-to-strengthen-indian-presence-with-7-6-mn-series-a-funding/',
    background: '#da2935',
    alt: 'Inc42',
  },
  {
    itemImage: Yourstory,
    date: '13-02-2020',
    content: `Amazon's early investor Madrona Venture Group pumps $7.6M in cloud startup Esper`,
    link:
      'https://yourstory.com/2020/02/cloud-startup-esper-funding-amazon-madrona-venture-group',
    background: '#ffffff',
    alt: 'YourStory',
  },

  {
    itemImage: Techcircle,
    date: '13-02-2020',
    content:
      'Android device management platform Esper raises Series A led by Madrona Venture Group',
    link:
      'https://www.techcircle.in/2020/02/13/android-device-management-platform-esper-raises-series-a-led-by-madrona-venture-group',
    background: '#ff6600',
    alt: 'TechCircle',
  },
  {
    itemImage: Inventiva,
    date: '13-02-2020',
    content:
      'Amazon’s early investor Madrona Venture Group pumps $7.6M in cloud startup Esper',
    link:
      'https://www.inventiva.co.in/stories/inventiva/devops-for-iot-device-fleets-ex-microsoft-amazon-leaders-raise-7-6m-for-seattle-area-startup-esper/',
    background: '#ffffff',
    alt: 'Inventiva',
  },
];
class NewsSectionTwo extends React.PureComponent<any, any> {
  render() {
    return (
      <div>
        <Section id="enhanced-devices">
          <GridContainer>
            {NewsArray.map((item: any, index: number) => (
              <GridItem key={index}>
                <GridTop style={{ background: item.background }}>
                  <ImgContainerTop>
                    <LazyLoadImage
                      alt={item.alt}
                      src={item.itemImage}
                      style={imageStyleTop}
                    />
                  </ImgContainerTop>
                </GridTop>
                <GridBottom>
                  <GridBottomDate>{item.date}</GridBottomDate>
                  <GridBottomText>{item.content}</GridBottomText>
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    <GridBottomLink>Read more</GridBottomLink>
                  </a>
                </GridBottom>
              </GridItem>
            ))}
          </GridContainer>
        </Section>
      </div>
    );
  }
}
export default NewsSectionTwo;
